module.exports = __webpack_public_path__ + "static/media/configure-chat.f88fbf0c.webp";